import { render } from "./Header.vue?vue&type=template&id=5ee8f3b5&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=5ee8f3b5&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3843889989/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee8f3b5"]])

export default __exports__